import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { ToastProvider } from './context/ToastContext';

// 🚀 IMPORTACIÓN CRÍTICA PARA COEXISTENCIA MIGRATORIA
import { StyledEngineProvider } from '@mui/material/styles';

if (process.env.NODE_ENV === 'development') {
    const originalWarn = console.warn;
    console.warn = (...args) => {
        if (args[0]?.includes('React does not recognize the') || args[0]?.includes('whitespace text nodes cannot be a child of')) return;
        originalWarn(...args);
    };
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <React.StrictMode>
        {/* 🚀 injectFirst empuja los estilos de MUI al fondo del <head> para que ganen prioridad sobre Tailwind */}
        <StyledEngineProvider injectFirst>
            <ToastProvider>
                <App />
            </ToastProvider>
        </StyledEngineProvider>
    </React.StrictMode>
);